import { Component, OnInit, Input, Inject, PLATFORM_ID, HostListener } from '@angular/core';
import { isPlatformBrowser, isPlatformServer } from '@angular/common';
import { Base64 } from '../../utilidades/utilidades';
import { Router } from '@angular/router';

import * as $ from 'jquery';

@Component({
    selector: 'app-slider',
    templateUrl: './slider.component.html',
    styleUrls: ['./slider.component.css']
})
export class SliderComponent implements OnInit {

	@Input() lista:any = [];
	@Input() tipo:string = '0';
	@Input() numberOfShow:number = 1;
	@Input() alto:number = 0;
    @Input() time:number = 0;
	@Input() ancho:number = 0;
	@Input() numberOfSlide:string = '1';

    init:boolean = true;

	currentConfig:any = {};

    constructor(
        private newRouter:Router,
        @Inject(PLATFORM_ID) private platformId: Object
    ) { }

    ngOnInit(): void {
        this.fnCalculate();
    }

    @HostListener('change') ngOnChanges() {
        this.fnCalculate();
    }

    fnCalculate(){
        var newInit = this.init;
        var anchoItem:any = 0;
        if( $("body").width() >= 768 && this.lista.length <= 4 ){
            newInit = false;
            anchoItem = ( this.ancho / this.numberOfShow );
        }else{
            if( $("body").width() >= 768 ){
                anchoItem = ( this.ancho / this.numberOfShow );
            }else{
                anchoItem = this.ancho;
            }
        }
        this.currentConfig = {
            anchoItem: anchoItem,
            anchoContent: ( this.ancho * this.lista.length),
            tipo: this.tipo,
            alto: this.alto,
            time: this.time,
            ancho: this.ancho,
            total: this.lista.length,
            numberOfShow: this.numberOfShow,
            numberOfSlide: this.numberOfSlide,
            init:newInit
        };
    }

    fnGetImage( newItem ){
        if( this.tipo === '1' || this.tipo === '2' ){
            return newItem.img;
        }else if( this.tipo === '3' || this.tipo === '4' ){
            if( newItem ){
                return newItem.fotografia;
            }else{
                return "";
            }
        }
    }

    fnSeleccion(newItem) {
        if (this.tipo === "1") {
            if (newItem.link.params) {
                var categorias = [];
                var marcas = [];
                var buscar = [];
                var hasMarca = false;
                var hasCategoria = false;
                var hasBuscar = false;
                newItem.link.params.forEach(function (newData) {
                    if (newData.categorias) {
                        hasCategoria = true;
                        categorias.push(newData.categorias);
                    }
                    if (newData.marcas) {
                        hasMarca = true;
                        marcas.push(newData.marcas);
                    }
                    if (newData.buscar) {
                        hasBuscar = true;
                        buscar.push(newData.buscar);
                    }
                });

                let url = '/tienda?';
                if (hasCategoria) url += `categorias=${categorias.join('&categorias=')}&`;
                if (hasMarca) url +=` marcas=${marcas.join('&marcas=')}&`;
                if (hasBuscar) url += `buscar=${buscar.join('&buscar=')}&`;

                url = url.slice(0, -1);

                this.newRouter.navigateByUrl(url);
            }else {
                if (newItem.link.path) {
                    this.newRouter.navigate([newItem.link.path]);
                }
            }
        } 
        else if( this.tipo === "2" ){
            let newEncoder = new Base64();
            this.newRouter.navigate(["tienda"], { queryParams: {marcas: [`${encodeURI(newEncoder.encode(`${newItem.id}`))}-${newItem.alias}`]} });
        }else if( this.tipo === "4" ){
            let newEncoder = new Base64();
            this.newRouter.navigate(["tienda"], { queryParams: {categorias: [`${encodeURI(newEncoder.encode(`${newItem.id}`))}-${newItem.alias}`]} });
        }
    }
}